import { Component } from '@angular/core';
import { AbstractFieldReadComponent } from '../base-field/abstract-field-read.component';

@Component({
  selector: 'ccd-read-complex-field-table',
  template: require('./read-complex-field-table.html'),
  styles: [require('./read-complex-field-table.scss')]
})
export class ReadComplexFieldTableComponent extends AbstractFieldReadComponent {}
